import { TableCell, TableHead, TableRow } from "@material-ui/core";
import React from "react";

import useStyles from "../useStyles";

/**
 * RegisterTableHeadコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RegisterTableHead() {
  // スタイル
  const styles = useStyles();

  return (
    <TableHead className={styles.registerTableHead}>
      <TableRow>
        <TableCell className={styles.tableHeader} colSpan={3}>
          登録履歴 (画面の更新によりリセットされます)
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          className={`${styles.tableHeader} ${styles.registerTimestampTableCell}`}
        >
          アップロード日時
        </TableCell>
        <TableCell
          className={`${styles.tableHeader} ${styles.registerFileNameTableCell}`}
        >
          ZIPファイル名
        </TableCell>
        <TableCell
          className={`${styles.tableHeader} ${styles.registerResultTableCell}`}
        >
          DB登録結果
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default RegisterTableHead;
